/*
@license
  Be Yours by roartheme (https://roartheme.co)
  Access unminified JS in assets/global.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://roartheme.co/blogs/beyours/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/
window.theme = window.theme || {};

theme.config = {
  mqlSmall: false,
  mediaQuerySmall: 'screen and (max-width: 749px)',
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  rtl: document.documentElement.getAttribute('dir') === 'rtl' ? true : false
};

theme.Currency = (function () {
  const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
      variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit
  };
})();

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, { rootMargin: `0px 0px ${threshold}px 0px` });

  observer.observe(options.element);
};

(function () {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(theme.config.mediaQuerySmall);
  theme.config.mqlSmall = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      theme.config.mqlSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.mqlSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  }

  // Page transition
  window.addEventListener('beforeunload', () => {
    document.body.classList.add('unloading');
  });
  window.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('loaded');

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });
  window.addEventListener('pageshow', (event) => {
    // Removes unload class when returning to page via history
    if (event.persisted) {
      document.body.classList.remove('unloading');
    }
  });

  // Viewport height
  function viewportHeight() {
    if (window.matchMedia('(max-width: 990px)')) {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    setHeaderBottomPosition();
  }
  window.addEventListener('resize', viewportHeight);
  window.addEventListener('DOMContentLoaded', viewportHeight);

  if (document.body.getAttribute('data-page-rendering') !== null) {
    // Improve initial load time by skipping the rendering of offscreen content
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          const el = entry.target;
          // Not currently in intersection area.
          if (entry.intersectionRatio == 0) {
            return;
          }
          // Trigger rendering for elements within scroll area that haven't already been marked.
          if (!el.markedVisible) {
            el.attributeStyleMap && el.attributeStyleMap.set('content-visibility', 'visible');
            el.markedVisible = true;
          }
        });
      },
      // Set a rendering 50px above and 100px below the main scroll area.
      { rootMargin: '50px 0px 100px 0px' }
    );
    const sections = document.querySelectorAll('.shopify-section + .shopify-section');
    sections.forEach((section) => { observer.observe(section); });
  }

  /*
  // Delay JavaScript until user interaction
  const loadScriptsTimer = setTimeout(loadScripts, 5000);
  const userInteractionEvents = ["mouseover", "mousemove", "keydown", "touchstart", "touchend", "touchmove", "wheel"];
  userInteractionEvents.forEach(function(event) {
    window.addEventListener(event, triggerScriptLoader, {
      passive: !0
    });
  });
  function triggerScriptLoader() {
    loadScripts();
    clearTimeout(loadScriptsTimer);
    userInteractionEvents.forEach(function(event) {
      window.removeEventListener(event, triggerScriptLoader, {
        passive: !0
      });
    });
  }
  function loadScripts() {
    document.querySelectorAll("script[data-type='lazy']").forEach(function(script) {
      script.setAttribute("src", script.getAttribute("data-src"));
    });
  }
  */
})();

// Prevent vertical scroll while using flickity sliders
(function () {
  var e = !1;
  var t;

  document.body.addEventListener('touchstart', function (i) {
    if (!i.target.closest('.flickity-slider')) {
      return e = !1;
    }
    e = !0;
    t = {
      x: i.touches[0].pageX,
      y: i.touches[0].pageY
    }
  })

  document.body.addEventListener('touchmove', function (i) {
    if (e && i.cancelable) {
      var n = {
        x: i.touches[0].pageX - t.x,
        y: i.touches[0].pageY - t.y
      };
      Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
    }
  }, { passive: !1 })
})();

function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = 'beyours:test';
  let storage;
  if (type === 'session') {
    storage = window.sessionStorage;
  }
  if (type === 'local') {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  }
  catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

function checkScrollbar() {
  const rect = document.body.getBoundingClientRect();
  return Math.round(rect.left + rect.right) < window.innerWidth;
}

function setScrollbarWidth() {
  if (checkScrollbar()) {
    const element = document.createElement('span');
    element.className = 'modal-scrollbar-measure', document.body.appendChild(element);

    const width = element.getBoundingClientRect().width - element.clientWidth;
    document.body.removeChild(element);
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
  }
}

function setHeaderBottomPosition() {
  const header = document.getElementById('shopify-section-header');
  if (header) {
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(header.getBoundingClientRect().bottom)}px`);
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'TAB') return; // If not TAB key

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
  if (charCode !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes('shopify:section')) {
    if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) {
      executeCallback = true;
    }
  }
  else if (event.type.includes('shopify:block') && event.target === domElement) {
    executeCallback = true;
  }
  if (executeCallback) {
    callback(event);
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.postLink2 = function (path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    for (const index in params[key]) {
      for (const key2 in params[key][index]) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", `${key}[${index}][${key2}]`);
        hiddenField.setAttribute("value", params[key][index][key2]);
        form.appendChild(hiddenField);
      }
    }
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.input.addEventListener('focus', this.onInputFocus.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  onInputFocus() {
    this.input.select();
  }
}
customElements.define('quantity-input', QuantityInput);

class DrawerCloseButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => this.dispatchEvent(new CustomEvent('drawer:force-close', { bubbles: true, cancelable: true, composed: true })));
  }
}
customElements.define('drawer-close-button', DrawerCloseButton);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      open: 'menu-drawer--open',
      opening: 'menu-drawer--opening',
      closing: 'menu-drawer--closing'
    };

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  setClasses(classes) {
    this.classes = classes;
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button[data-close]').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));

    this.addEventListener('drawer:force-close', (event) => {
      event.stopPropagation();
      this.closeMenuDrawer(event);
    });
  }

  onKeyUp(event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement = false) {
    setScrollbarWidth();
    setHeaderBottomPosition();

    if (summaryElement) {
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
    }

    setTimeout(() => {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      document.body.addEventListener('click', this.onBodyClickEvent);
    });
    document.body.classList.add(this.classes.opening);

    this.openAnimation();
    setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', '');
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      }, 10);
    });
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.classList.add('menu-closing');
      removeTrapFocus(elementToFocus);

      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove(this.classes.open);
      document.body.classList.add(this.classes.closing);

      this.closeAnimation(this.mainDetailsToggle);
      this.dispatchEvent(new CustomEvent('close'));
      document.dispatchEvent(new CustomEvent('menudrawer:close'));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const target = event.currentTarget;
    if (target.classList.contains('noclose')) return;

    const detailsElement = target.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  openAnimation() {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      }
      else {
        document.body.classList.remove(this.classes.opening);
        document.body.classList.add(this.classes.open);
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      }
      else {
        if (detailsElement === this.mainDetailsToggle) {
          document.body.classList.remove(this.classes.closing);
          detailsElement.classList.remove('menu-closing');
        }
        detailsElement.removeAttribute('open');

        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.closeMenuDrawer(event);
  }
}
customElements.define('menu-drawer', MenuDrawer);

class CartDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'mini-cart--open',
      opening: 'mini-cart--opening',
      closing: 'mini-cart--closing'
    });
  }
}
customElements.define('cart-drawer', CartDrawer);

class FacetDrawer extends MenuDrawer {
  constructor() {
    super();

    if (this.dataset.desktop == 'true') {
      this.setClasses({
        open: 'facet-horizontal--open',
        opening: 'facet-horizontal--opening',
        closing: 'facet-horizontal--closing'
      });
    }
    else {
      this.setClasses({
        open: 'facet-drawer--open',
        opening: 'facet-drawer--opening',
        closing: 'facet-drawer--closing'
      });
    }
  }
}
customElements.define('facet-drawer', FacetDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'menu-mobile--open',
      opening: 'menu-mobile--opening',
      closing: 'menu-mobile--closing'
    });
  }
}
customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
      if (charCode === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    setScrollbarWidth();
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    if (!this.button) return;

    this.button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(this.button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!this.poster) return;

    this.poster.addEventListener('click', this.loadContent.bind(this));
  }

  connectedCallback() {
    if (this.getAttribute('data-autoplay') !== 'true') return;
    if (this.getAttribute('loaded')) return;
    requestAnimationFrame(() => this.loadContent({ focus: false, pauseOthers: false }));
  }

  loadContent({ focus = true, pauseOthers = true } = {}) {
    if (pauseOthers) window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      if (content.querySelector('video-section')) {
        const el = this.appendChild(content);
        if (focus) el.focus();
      } else {
        this.setAttribute('loaded', true);
        const el = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) el.focus();
      }
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.currentPage === 1 && this.currentPage === this.totalPages) {
      this.classList.add('slider--no-buttons');
    } else {
      this.classList.remove('slider--no-buttons');
    }

    if (this.enableSliderLooping) return;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (isFirstSlide || this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (isLastSlide || this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slideScrollPosition = theme.config.rtl ? this.slideScrollPosition * -1 : this.slideScrollPosition;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}
customElements.define('slider-component', SliderComponent);

class ThumbnailSlider extends SliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();

    const variantItems = this.querySelectorAll('.thumbnail-list_item--variant:not(.is-active)');
    this.slider.dataset.mediaCount = this.sliderItems.length - variantItems.length;

    if (this.querySelector('[data-gang-option]')) {
      const inactiveGangItems = this.querySelectorAll('[data-gang-option]:not(.gang__active)');
      this.slider.dataset.mediaCount = this.sliderItems.length - inactiveGangItems.length;
    }

    if (this.slider.dataset.mediaCount < 2) this.classList.add('hidden');
  }
}
customElements.define('thumbnail-slider', ThumbnailSlider);

class ProductGallery extends SliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();

    const gallerySliderButtons = this.querySelector('.slider-buttons');
    if (gallerySliderButtons && this.querySelector('[data-gang-option]')) {
      if (this.querySelectorAll('.product__media-item.gang__active').length < 2) {
        gallerySliderButtons.classList.add('hidden');
      } else {
        gallerySliderButtons.classList.remove('hidden');
      }
    }

    this.cursor = this.querySelector('.gallery-cursor');
    if (!this.cursor) return;

    const images = this.querySelectorAll('.product__modal-opener--image');
    images.forEach((image) => image.addEventListener('mousemove', this.onMoveHandler.bind(this)));
    images.forEach((image) => image.addEventListener('mouseenter', this.onEnterHandler.bind(this)));
    images.forEach((image) => image.addEventListener('mouseleave', this.onLeaveHandler.bind(this)));
  }

  onMoveHandler(event) {
    this.cursor.style.left = `${event.clientX - 32}px`;
    this.cursor.style.top = `${event.clientY - 32}px`;
  }

  onEnterHandler() {
    this.cursor.classList.add('show');
  }

  onLeaveHandler() {
    this.cursor.classList.remove('show');
  }

  update() {
    super.update();

    if (this.currentPageElement && this.pageTotalElement) {
      const currentElement = this.sliderItemsToShow[this.currentPage - 1];
      if (currentElement) {
        if (currentElement.querySelector('.media')) {
          this.slider.style.setProperty('--force-image-ratio-percent', currentElement.querySelector('.media').style.getPropertyValue('--image-ratio-percent'));
        }
      }
    }
  }

  goToFirstSlide() {
    this.slider.scrollTo({
      left: 0
    });
  }
}
customElements.define('product-gallery', ProductGallery);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', this.onVariantChange);

    this.updateOptions();
    this.updateMasterId();
    this.setAvailability();
    this.initSwitchHandle()
    this.updateGiftBox()
    this.updatediscountCodeBox()
    this.updateCustomImageSlide();
  }

  onVariantChange(event) {
    this.syncCustomVariantInput(event);
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();
    this.validateGang();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.setAvailabilityInUnavailable();
    } else {
      if (this.gangOption) {
        this.updateGangMedia();
      } else {
        this.updateMedia();
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.setAvailability();
      this.updateGiftBox()
      this.updatediscountCodeBox()
      this.updateCustomImageSlide();
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
          variant: this.currentVariant
        }
      }));
    }

    this.handleStickyCart(event.target);
  }

  handleStickyCart(target) {
    const stickyCart = document.getElementById(`sticky-cart-${this.dataset.section}`);
    if (!stickyCart) return;

    const attribute = target.getAttribute('name');

    const selector = this.isCustomPicker()
      ? `#sticky-cart-${this.dataset.section} variant-radios[data-section="${this.dataset.section}"] [name="${attribute}"], #sticky-cart-${this.dataset.section} variant-selects[data-section="${this.dataset.section}"] [name="${attribute}"]`
      : `variant-radios[data-section="${this.dataset.section}"] [name="${attribute}"], variant-selects[data-section="${this.dataset.section}"] [name="${attribute}"]`;

    document.querySelectorAll(selector)
      .forEach((input) => {
        if (input.tagName === 'INPUT') {
          input.checked = input.value === target.value;
        }
        else {
          input.value = target.value;
        }
      });

    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const image = document.querySelector('.sticky-cart__content-image img');
    if (image) {
      image.srcset = `${this.currentVariant.featured_media.preview_image.src}&width=70 1x, ${this.currentVariant.featured_media.preview_image.src}&width=140 2x`;
      image.src = `${this.currentVariant.featured_media.preview_image.src}&width=70`;
      image.width = 70;
      image.height = Math.ceil(70 / this.currentVariant.featured_media.preview_image.aspect_ratio);
    }
  }

  isCustomPicker() {
    return this.dataset.pickerType === 'custom';
  }

  syncCustomVariantInput(event) {
    if (!this.isCustomPicker()) return;

    const target = event.target;
    const targetVariantId = target.dataset.variantid;

    if (targetVariantId) return;

    const currentInput = this.querySelector(
      `.custom-options-varants-slide[data-type='${target.value}'] input[type="radio"]`
    );
    if (currentInput) currentInput.checked = true;
  }

  updateCustomImageSlide() {
    if (!this.isCustomPicker()) return;
    if (!this.currentVariant) return;
    if (this.options.length < 2) return;

    this.querySelectorAll('.custom-options-varants-slide').forEach((item) => {
      item.classList.remove('selected');
      if (item.getAttribute('data-type') == this.options[0]) {
        item.classList.add('selected');
      }
    });
  }
  initSwitchHandle() {
    this.productInfoEl = document.getElementById(`ProductInfo-${this.dataset.section}`)
    this.giftBlocks = [...this.productInfoEl.querySelectorAll('.product-info__gift-block')]
    this.discountcodeBlocks = this.productInfoEl.querySelectorAll('.discount-code')
  }
  updatediscountCodeBox() {
    if (!this.currentVariant) return;
    if (this.discountcodeBlocks.length < 1) return
    this.discountcodeBlocks.forEach(code => {
      if (code.getAttribute('variant-id') === "" || code.getAttribute('variant-id').includes(this.currentVariant.id)) {
        code.classList.add('active')
      } else {
        code.classList.remove('active')
      }
    })
  }
  updateGiftBox() {
    if (!this.currentVariant) return;
    if (Array.isArray(this.giftBlocks)) {
      this.updateGiftBoxHandle(this.giftBlocks)
    }
  }
  updateStock(responseText) {
    const id = `stock-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(id);
    const source = html.getElementById(id);
    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove("visibility-hidden");
  }
  updateGiftBoxHandle(element) {
    const activeGift = element.find(
      (item) => item.getAttribute("variant-id") == ""
    );
    if (activeGift) {
      activeGift.classList.add("active");
      return;
    }
    let index = null;
    element.forEach((item, idx) => {
      item.classList.remove("active");
      if (
        index == null &&
        item.getAttribute("variant-id").includes(this.currentVariant.id)
      ) {
        index = idx;
      }
    });
    if (index !== null) {
      element[index].classList.add("active");
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData()?.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  validateGang() {
    const mediaItemWithGang = document.querySelector(`#shopify-section-${this.dataset.section} [data-gang-option], quick-view-drawer details[open] [data-gang-option]`);
    if (mediaItemWithGang) {
      this.gangOption = mediaItemWithGang.dataset.gangOption;
    }
  }

  updateGangMedia() {
    if (!this.gangOption) return;

    const variantInputWrapper = this.querySelector('.variant-input-wrapper[data-option-slug="' + this.gangOption + '"]');
    if (variantInputWrapper) {
      this.gangIndex = variantInputWrapper.dataset.optionIndex;
    } else {
      this.gangOption = null;
    }

    if (!this.currentVariant) return;
    //if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    const gangValue = this.getSlug(this.currentVariant[this.gangIndex]);
    if (this.currentGangValue !== gangValue) {
      document.querySelectorAll(
        `#shopify-section-${this.dataset.section} [data-gang-connect], quick-view-drawer details[open] [data-gang-connect]`
      ).forEach(function (media) {
        media.classList.remove('gang__active');
      });

      this.currentGangValue = gangValue;
      var gangConnect = this.gangOption + '_' + gangValue;
      const newMedias = document.querySelectorAll(
        `#shopify-section-${this.dataset.section} [data-gang-connect="${gangConnect}"], quick-view-drawer details[open] [data-gang-connect="${gangConnect}"]`
      );

      if (!newMedias.length) return;
      Array.from(newMedias).reverse().forEach(function (newMedia) {
        newMedia.classList.add('gang__active');
        let parent = newMedia.parentElement;
        if (parent.firstChild != newMedia) {
          // parent.prepend(newMedia);
          parent.classList.add('product__media-no-animate');
        }
      });

      const thumbnailSlider = document.getElementById(`GalleryThumbnails-${this.dataset.section}`);
      if (thumbnailSlider) {
        const inactiveItems = thumbnailSlider.querySelectorAll('.thumbnail-list__item:not(.gang__active)');
        thumbnailSlider.slider.dataset.mediaCount = thumbnailSlider.sliderItems.length - inactiveItems.length;
        if (thumbnailSlider.slider.dataset.mediaCount < 2) {
          thumbnailSlider.classList.add('hidden');
        } else {
          thumbnailSlider.classList.remove('hidden');
        }
        thumbnailSlider.resetPages();
      }

      if (!mediaGallery) {
        const productGallery = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery, quick-view-drawer details[open] product-gallery`)
        if (productGallery) {
          productGallery.resetPages();
          productGallery.goToFirstSlide();
        }
      }

      const gallerySliderButtons = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery .slider-buttons, quick-view-drawer details[open] product-gallery .slider-buttons`);
      if (gallerySliderButtons) {
        if (document.querySelectorAll(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`).length < 2) {
          gallerySliderButtons.classList.add('hidden');
        } else {
          gallerySliderButtons.classList.remove('hidden');
        }
      }
    }

    if (!this.currentVariant.featured_media) {
      if (!document.querySelectorAll(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active.is-active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active.is-active`).length) {
        document.querySelector(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`).classList.add('is-active');
      }
      return;
    }

    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === 'undefined';
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, scrollIntoView);
    }

  }

  getSlug(someString) {
    return someString.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;

    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    // parent.prepend(newMedia);
    parent.classList.add('product__media-no-animate');

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === 'undefined';
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, scrollIntoView);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment, #product-form-${this.dataset.section}--alt`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        this.updateSKU(responseText);
        this.updatePrice(responseText);
        this.updatePriceAlt(responseText);
        this.updateStock(responseText);
        this.updateColorName(responseText);
        this.updateInventoryStatus(responseText);
        this.updateVariantDetails(responseText)
        if (this.currentVariant) this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        document.dispatchEvent(new CustomEvent('productInfo:loaded'));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  updateSKU(responseText) {
    const id = `sku-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }
  updateVariantDetails(responseText) {
    const id = `variant-details-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(id);
    const source = html.getElementById(id);
    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove("visibility-hidden");
  }
  updatePrice(responseText) {
    const id = `price-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);
    const priceElement = source.querySelector('.price__regular .money');
    const salePriceElement = source.querySelector('.price__sale .money');
    const saveTag = source.querySelector('.custom-save-tag');
    if (priceElement && salePriceElement) {
      const priceText = priceElement.textContent;
      const salePriceText = salePriceElement.textContent;
      const price = parseFloat(priceText.replace(/[$,]/g, '').replace(/\.\d+$/, ''));
      const salePrice = parseFloat(salePriceText.replace(/[$,]/g, '').replace(/\.\d+$/, ''));
      const discountAmount = salePrice - price;
      const discountPercentage = (discountAmount / salePrice) * 100;
      saveTag.textContent = `Save ${discountPercentage.toFixed(0)}%`;
    }
    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updatePriceAlt(responseText) {
    const id = `price-${this.dataset.section}--alt`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updateColorName(responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    for (let index = 1; index <= 3; index++) {
      const id = index > 1 ? `color-${this.dataset.section}-${index}` : `color-${this.dataset.section}`;
      const destination = document.getElementById(id);
      const source = html.getElementById(id);

      if (source && destination) destination.innerHTML = source.innerHTML;
      if (destination) destination.classList.remove('visibility-hidden');
    }
  }

  updateInventoryStatus(responseText) {
    const id = `inventory-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`);
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', true);
        if (text) addButton.textContent = text;
      }
      else {
        addButton.removeAttribute('disabled');
        addButton.textContent = addButton.dataset.preOrder === 'true' ? window.variantStrings.preOrder : window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    });
  }

  setUnavailable() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`);
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.textContent = window.variantStrings.unavailable;

      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.add('visibility-hidden');

      const priceAlt = document.getElementById(`price-${this.dataset.section}--alt`);
      if (priceAlt) priceAlt.classList.add('visibility-hidden');

      const inventory = document.getElementById(`inventory-${this.dataset.section}`);
      if (inventory) inventory.classList.add('visibility-hidden');
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  setAvailability() {
    if (!this.currentVariant) return;

    this.querySelectorAll('.variant-input-wrapper').forEach(group => {
      this.disableVariantGroup(group);
    });

    const currentlySelectedValues = this.currentVariant.options.map((value, index) => { return { value, index: `option${index + 1}` } })
    const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant);

    for (var [option, values] of Object.entries(initialOptions)) {
      this.manageOptionState(option, values);
    }
  }

  setAvailabilityInUnavailable() {
    this.querySelectorAll('.variant-input-wrapper').forEach(group => {
      this.disableVariantGroup(group);
    });

    const currentlySelectedValues = this.options.map((value, index) => { return { value, index: `option${index + 1}` } })
    const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant);

    for (var [option, values] of Object.entries(initialOptions)) {
      this.manageOptionState(option, values);
    }
  }

  enableVariantOption(group, obj) {
    const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
    group.querySelector('option[value="' + value + '"]').disabled = false;
  }

  disableVariantGroup(group) {
    group.querySelectorAll('option').forEach((option) => {
      option.disabled = true;
    });
  }

  manageOptionState(option, values) {
    const group = this.querySelector('.variant-input-wrapper[data-option-index="' + option + '"]');

    // Loop through each option value
    values.forEach(obj => {
      this.enableVariantOption(group, obj);
    });
  }

  createAvailableOptionsTree(variants, currentlySelectedValues) {
    // Reduce variant array into option availability tree
    return variants.reduce((options, variant) => {

      // Check each option group (e.g. option1, option2, option3) of the variant
      Object.keys(options).forEach(index => {

        if (variant[index] === null) return;

        let entry = options[index].find(option => option.value === variant[index]);

        if (typeof entry === 'undefined') {
          // If option has yet to be added to the options tree, add it
          entry = { value: variant[index], soldOut: true }
          options[index].push(entry);
        }

        const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1')
        const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2')

        switch (index) {
          case 'option1':
            // Option1 inputs should always remain enabled based on all available variants
            entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            break;
          case 'option2':
            // Option2 inputs should remain enabled based on available variants that match first option group
            if (currentOption1 && variant['option1'] === currentOption1.value) {
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            }
          case 'option3':
            // Option 3 inputs should remain enabled based on available variants that match first and second option group
            if (
              currentOption1 && variant['option1'] === currentOption1.value
              && currentOption2 && variant['option2'] === currentOption2.value
            ) {
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            }
        }
      })

      return options;
    }, { option1: [], option2: [], option3: [] })
  }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  enableVariantOption(group, obj) {
    const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
    const inputs = group.querySelectorAll('input[data-option-value="' + value + '"]');

    inputs.forEach((input) => {
      input.removeAttribute('disabled');

      if (obj.soldOut && !this.isCustomPicker()) {
        input.setAttribute('disabled', '');
      }
    });
  }

  disableVariantGroup(group) {
    group.querySelectorAll('input').forEach((input) => {
      input.setAttribute('disabled', '');
    });
  }
}
customElements.define('variant-radios', VariantRadios);

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(evt) {
    if (document.body.classList.contains('template-cart') || !window.shopSettings.cartDrawer) {
      return;
    }

    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton.classList.contains('loading')) {
      return;
    }

    this.handleErrorMessage();

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);

    if (this.miniCart) {
      formData.append('sections', this.miniCart.getSectionsToRender().map((section) => section.id));
    }
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        if (this.miniCart) {
          this.miniCart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

    if (this.errorMessageWrapper) {
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    else {
      if (errorMessage) {
        alert(errorMessage);
      }
    }
  }
}
customElements.define('product-form', ProductForm);

class FormState extends HTMLElement {
  constructor() {
    super();

    this.formInputs = this.querySelectorAll('input,select,textarea');
    this.form = this.querySelector('form');

    this.formInputs.forEach((input) => {
      input.addEventListener('input', this.onInputChange.bind(this));
      input.addEventListener('blur', this.onInputChange.bind(this));
    });

    if (this.form) this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  onInputChange(event) {
    this.handleInputCheck(event.target);
  }

  onSubmitHandler(event) {
    let valid = !0;

    this.formInputs.forEach((input) => {
      if (!this.handleInputCheck(input)) {
        valid = !1;
      }
    });

    if (!valid) {
      event.preventDefault();
      return;
    }
  }

  handleInputCheck(input) {
    if (input.classList.contains('required')) {

      if (input.value.length === 0 || input.value === input.dataset.empty) {
        input.classList.remove('valid');
        input.classList.add('invalid');

        return !1;
      }
      else {
        input.classList.remove('invalid');
        input.classList.add('valid');

        return !0;
      }
    }

    return !0;
  }
}
customElements.define('form-state', FormState);

class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.addEventListener('click', this.onClickHandler.bind(this));
  }

  onClickHandler() {
    const variantId = this.dataset.variantId;

    if (variantId) {
      if (document.body.classList.contains('template-cart') || !window.shopSettings.cartDrawer) {
        Shopify.postLink(window.routes.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1
          },
        });
        return;
      }

      this.setAttribute('disabled', true);
      this.classList.add('loading');
      const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      });

      fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status === 422) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
              detail: {
                errorMessage: parsedState.description
              }
            }));
          }
          else {
            this.miniCart && this.miniCart.renderContents(parsedState);

            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: parsedState
              }
            }));
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.classList.remove('loading');
          this.removeAttribute('disabled');
        });
    }
  }
}
customElements.define('add-to-cart', AddToCart);

class UseAnimate extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    this.setAttribute('animate', '');
  }
}
customElements.define('use-animate', UseAnimate);

class AnimateSticky extends HTMLElement {
  constructor() {
    super();
    this.scrollTimeout = null;
    this.isRevealed = false;
    this._isInitialized = false;
  }

  connectedCallback() {
    // window.addEventListener("load", () => {
    if (this._isInitialized) return;
    this._isInitialized = true;

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScrollHandler, { passive: true });

    this.onScrollHandler();
    // });
  }

  disconnectedCallback() {
    if (this.onScrollHandler) {
      window.removeEventListener("scroll", this.onScrollHandler);
    }
    if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const elementTop = this.getOffsetTop(this);

    if (this.isRevealed) {
      this.reset();
    }

    if (this.scrollTimeout) clearTimeout(this.scrollTimeout);

    if (scrollTop <= elementTop) {
      this.scrollTimeout = null;
      return;
    }

    this.scrollTimeout = setTimeout(() => {
      this.reveal();
      this.scrollTimeout = null;
    }, 500);
  }

  reveal() {
    this.setAttribute("animate", "");
    this.isRevealed = true;
  }

  reset() {
    this.removeAttribute("animate");
    this.isRevealed = false;
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
}

customElements.define("animate-sticky", AnimateSticky);

class VideoSection extends HTMLElement {
  constructor() {
    super();

    this.background = this.dataset.initMode !== 'template';

    if (this.background) {
      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
    else {
      this.init();
    }
  }

  init() {
    this.parentSelector = this.dataset.parent || '.media-wrapper';
    this.time = this.dataset.time || 50
    this.parent = this.closest(this.parentSelector);

    switch (this.dataset.type) {
      case 'youtube':
        this.initYoutubeVideo();
        break;

      case 'vimeo':
        this.initVimeoVideo();
        break;

      case 'mp4':
        this.initMp4Video();
        break;
    }
  }

  initYoutubeVideo() {
    this.setAsLoading();
    this.loadScript('youtube').then(this.setupYoutubePlayer.bind(this));
  }

  initVimeoVideo() {
    this.setAsLoading();
    this.loadScript('vimeo').then(this.setupVimeoPlayer.bind(this));
  }

  initMp4Video() {
    const player = this.querySelector('video');

    if (player && !player.getAttribute('data-not-autoplay')) {
      const promise = player.play();

      // Edge does not return a promise (video still plays)
      if (typeof promise !== 'undefined') {
        promise.then(function () {
          // playback normal
        }).catch(function () {
          player.setAttribute('controls', '');
        });
      }
    }
  }

  loadScript(videoType) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = videoType === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
    });
  }

  setAsLoading() {
    this.parent.setAttribute('loading', true);
  }

  setAsLoaded() {
    this.parent.removeAttribute('loading');
    this.parent.setAttribute('loaded', true);
  }

  setupYoutubePlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.YT) {
        window.YT.ready(() => {
          const element = document.createElement('div');
          this.appendChild(element);

          this.player = new YT.Player(element, {
            videoId: videoId,
            playerVars: {
              showinfo: 0,
              controls: !this.background,
              fs: !this.background,
              rel: 0,
              height: '100%',
              width: '100%',
              iv_load_policy: 3,
              html5: 1,
              loop: 1,
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1
            },
            events: {
              onReady: this.onYoutubeReady.bind(this),
              onStateChange: this.onYoutubeStateChange.bind(this)
            }
          });
          clearInterval(playerInterval);
        });
      }
    }, this.time);
  }

  onYoutubeReady() {
    this.iframe = this.querySelector('iframe'); // iframe once YT loads
    this.iframe.setAttribute('tabindex', '-1');
    this.background && this.player.mute();
    if (typeof this.player.playVideo === 'function') this.player.playVideo();

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        entry.isIntersecting ? this.youtubePlay() : this.youtubePause();
      });
    }, { rootMargin: '0px 0px 50px 0px' });

    observer.observe(this.iframe);
  }

  onYoutubeStateChange(event) {
    switch (event.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (this.attemptedToPlay) {
          this.setAsLoaded();
          this.closest('.banner').classList.add('video-interactable');
        }
        break;
      case 0: // ended, loop it
        this.youtubePlay();
        break;
      case 1: // playing
        this.setAsLoaded();
        break;
      case 3: // buffering
        this.attemptedToPlay = true;
        break;
    }
  }

  youtubePlay() {
    if (this.background && this.player && typeof this.player.playVideo === 'function') {
      this.player.playVideo();
    }
  }

  youtubePause() {
    if (this.background && this.player && typeof this.player.pauseVideo === 'function') {
      this.player.pauseVideo();
    }
  }

  setupVimeoPlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.Vimeo) {
        this.player = new Vimeo.Player(this, {
          id: videoId,
          autoplay: true,
          autopause: false,
          background: this.background,
          controls: !this.background,
          loop: true,
          height: '100%',
          width: '100%'
        });
        this.player.ready().then(this.onVimeoReady.bind(this));

        clearInterval(playerInterval);
      }
    }, 50);
  }

  onVimeoReady() {
    this.iframe = this.querySelector('iframe');
    this.iframe.setAttribute('tabindex', '-1');

    this.background && this.player.setMuted(true);

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.vimeoPlay();
        } else {
          this.vimeoPause();
        }
      });
    }, { rootMargin: '0px 0px 50px 0px' });

    observer.observe(this.iframe);
  }

  vimeoPlay() {
    if (this.background && this.player && typeof this.player.play === 'function') {
      this.player.play();
    }
  }

  vimeoPause() {
    if (this.background && this.player && typeof this.player.pause === 'function') {
      this.player.pause();
    }
  }
}
customElements.define('video-section', VideoSection);

class SelectWrapper extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });

    this.select = this.querySelector('select');
    if (this.select) {
      this.select.addEventListener('change', this.handleSelectChange.bind(this));
    }
  }

  init() {
    const style = window.getComputedStyle(this.select);
    const value = this.select.options[this.select.selectedIndex].text;

    const text = document.createElement('span');
    text.style.fontFamily = style.fontFamily;
    text.style.fontSize = style.fontSize;
    text.style.fontWeight = style.fontWeight;
    text.style.visibility = 'hidden';
    text.style.position = 'absolute';
    text.innerHTML = value;

    document.body.appendChild(text);
    const width = text.clientWidth;

    this.style.setProperty('--width', `${width}px`);
    text.remove();
  }

  handleSelectChange() {
    this.init();
  }
}
customElements.define('select-wrapper', SelectWrapper);

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed), // 100px going to move for
      space: 100, // 100px
    };

    this.promotion = this.querySelector('.promotion');

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < 10; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.clone.setAttribute('aria-hidden', true);
        this.appendChild(this.clone);

        const imageWrapper = this.clone.querySelector('.media-wrapper');
        if (imageWrapper) {
          imageWrapper.classList.remove('loading');
        }
      }

      const animationTimeFrame = (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
      this.style.setProperty('--duration', `${animationTimeFrame}s`);

      // pause when out of view
      const observer = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.scrollingPlay();
          } else {
            this.scrollingPause();
          }
        });
      }, { rootMargin: '0px 0px 50px 0px' });

      observer.observe(this);
    }
  }

  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-promotion', ScrollingPromotion);

class AccordionTab extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.accordion__content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();

    this.details.style.overflow = 'hidden';
    if (this.isClosing || !this.details.open) {
      this.open();
    }
    else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const summaryStyle = window.getComputedStyle(this.summary);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop)}px`;

    this.details.style.height = startHeight;
    this.details.style.overflow = 'hidden';

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => {
      this.isClosing = false;
      this.details.style.height = '';
      this.details.style.overflow = '';
    };
  }

  open() {
    const otherTabs = this.parentElement.querySelectorAll('accordion-tab');

    if (otherTabs.length > 0) {
      otherTabs.forEach(tab => {
        if (tab !== this && tab.details.open) {
          tab.shrink();
        }
      });
    }
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;

    const summaryStyle = window.getComputedStyle(this.summary);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop) + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = '';
    this.details.style.overflow = '';
  }
}
customElements.define('accordion-tab', AccordionTab);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 600px 0px' }).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('product-recommendations', ProductRecommendations);

class SwiperComponent extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.section = document.getElementById(this.getAttribute('section-id'));
    this.observerEl = this.section || this
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '100px' });
    this.observer.observe(this.observerEl);
  }
  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) { this.init(); this.observer.unobserve(this.observerEl); }
    });
  }
  init() {
    this.swiperElement = this.querySelector(`#${this.getAttribute('swiper-id')}`);
    this.options = JSON.parse(this.getAttribute('data-options'));
    this.prevButton = this.section.querySelector('.swiper-component-prev-button');
    this.nextButton = this.section.querySelector('.swiper-component-next-button');
    this.pages = this.querySelectorAll('.swiper-component-page-item');
    this.switchDefaultClassList = this.getAttribute('data-default-classlist')?.split(',');
    this.switchActiveClassList = this.getAttribute('data-active-classlist')?.split(',');
    this.lastActiveIndex = 0;

    if (Array.isArray(this.switchDefaultClassList) && this.switchDefaultClassList.length > 0) {
      this.switchNodes = this.querySwitchNodes();
      this.options.on = { transitionStart: this.handleTransitionStart.bind(this) };
    }
    if (this.getAttribute('button-status') && !this.options.loop) {
      this.options.on = {
        slideChange: (swiper) => {
          this.prevButton.style.opacity = swiper.isBeginning ? "0.4" : "1"
          this.nextButton.style.opacity = swiper.isEnd ? "0.4" : "1"
        }
      }
    }
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.swiper.slidePrev(this.options.speed || 800));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.swiper.slideNext(this.options.speed || 800));
    }
    if (this.pages) {
      this.pages.forEach((page, index) => {
        page.addEventListener('click', () => {
          this.options.loop ? this.swiper.slideToLoop(index) : this.swiper.slideTo(index);
        });
      });
    }
    if (this.getAttribute("custom-pagination")) {
      const customPagination = this.section.querySelectorAll(`.${this.getAttribute("custom-pagination")}`)
      customPagination.forEach((item, index) => {
        item.addEventListener('click', () => {
          this.options.loop ? this.swiper.slideToLoop(index) : this.swiper.slideTo(index);
        });
      });
    }
    this.swiper = new Swiper(this.swiperElement, this.options);
    if (this.getAttribute('control-id')) {
      this.controlOptions = JSON.parse(this.getAttribute('control-options'));
      this.controlOptions.controller = { control: this.swiper }
      this.controlSwiper = new Swiper(`#${this.getAttribute('control-id')}`, this.controlOptions);

    }
  }
  querySwitchNodes() {
    let switchNodes = [];
    this.switchDefaultClassList.forEach(className => switchNodes.push(this.section.querySelectorAll(`.${className}`)));
    return switchNodes;
  }
  handleTransitionStart(swiper) {
    const newActiveIndex = swiper.realIndex;
    this.switchNodes.forEach((nodes, idx) => {
      const lastActiveNode = nodes[this.lastActiveIndex];
      if (lastActiveNode) {
        lastActiveNode.classList.remove(this.switchActiveClassList[idx]);
      }
    });

    this.switchNodes.forEach((nodes, idx) => {
      const newActiveNode = nodes[newActiveIndex];
      if (newActiveNode) {
        newActiveNode.classList.add(this.switchActiveClassList[idx]);
      }
    });
    this.lastActiveIndex = newActiveIndex;
  }
}

customElements.define('swiper-component', SwiperComponent);


class CustomCountDown extends HTMLElement {
  static DAY = 86400000;
  static HOUR = 3600000;
  static MIN = 60000;
  static SEC = 1000;

  constructor() {
    super();
    this.endDateStr = this.getAttribute('end-date');
    this.durationMinutes = this.getAttribute('duration-minutes');
    this.interval = null;
    this.storageKey = this.getStorageKey();
  }

  getStorageKey() {
    const base = this.getAttribute('duration-minutes') || 'fixed';
    return `countdown_end_${base}`;
  }

  connectedCallback() {
    if (!this.endDateStr && !this.durationMinutes) return;

    if (this.hasAttribute('init-countdown')) {
      this.init();
      return;
    }

    this.observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        this.init();
        this.observer.disconnect();
      }
    });

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  init() {
    if (this.interval) return;

    this.dayEl = this.querySelector('.block-time-day');
    this.hoursEl = this.querySelector('.block-time-hrs');
    this.minsEl = this.querySelector('.block-time-mins');
    this.secsEl = this.querySelector('.block-time-secs');

    if (this.endDateStr) {
      this.endTime = new Date(this.endDateStr).getTime();
    } else if (this.durationMinutes) {
      const storedEnd = sessionStorage.getItem(this.storageKey);

      if (storedEnd) {
        this.endTime = Number(storedEnd);
      } else {
        const durationMs =
          Number(this.durationMinutes) * CustomCountDown.MIN;

        if (!isNaN(durationMs)) {
          this.endTime = Date.now() + durationMs;
          sessionStorage.setItem(this.storageKey, this.endTime);
        }
      }
    }

    if (!this.endTime || isNaN(this.endTime)) return;

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  update() {
    const diff = this.endTime - Date.now();

    if (diff <= 0) {
      this.render(0, 0, 0, 0);
      clearInterval(this.interval);
      this.interval = null;

      if (this.durationMinutes) {
        sessionStorage.removeItem(this.storageKey);
      }

      return;
    }

    const { DAY, HOUR, MIN, SEC } = CustomCountDown;

    const days = Math.floor(diff / DAY);
    const hours = Math.floor((diff % DAY) / HOUR);
    const mins = Math.floor((diff % HOUR) / MIN);
    const secs = Math.floor((diff % MIN) / SEC);

    this.render(days, hours, mins, secs);
  }

  render(days, hours, mins, secs) {
    if (this.dayEl) this.dayEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minsEl) this.minsEl.textContent = String(mins).padStart(2, '0');
    if (this.secsEl) this.secsEl.textContent = String(secs).padStart(2, '0');
  }
}

customElements.define('count-down-component', CustomCountDown);


class SlidingCardWrapper extends HTMLElement {
  constructor() {
    super();
    this.imageWrapperMove = this.imageWrapperMoveFc.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
  }

  connectedCallback() {
    this.upImage = this.querySelector('.up-image');
    this.button = this.querySelector('.sliding-card-wrapper-button');
    this.imageWrapperWidth = this.getBoundingClientRect().width;
    this.minRatio = parseFloat(this.getAttribute('min-ratio') ?? 0.1);
    this.maxRatio = parseFloat(this.getAttribute('max-ratio') ?? 0.9);
    this.minLeft = this.imageWrapperWidth * this.minRatio;
    this.maxLeft = this.imageWrapperWidth * this.maxRatio;
    if (this.getAttribute('swiper-id')) {
      this.swiper = this.closest(`#${this.getAttribute('swiper-id')}`).swiper;
    }

    this.button.addEventListener("mousedown", this.onMouseDown.bind(this));
    this.button.addEventListener("touchstart", this.onTouchStart.bind(this));
  }

  onMouseDown(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.getAttribute('swiper-id')) {
      this.swiper.allowTouchMove = false;
    }
    this.addEventListener("mousemove", this.imageWrapperMove);
    document.addEventListener("mouseup", this.onMouseUp);
  }

  onTouchStart(e) {
    if (this.getAttribute('swiper-id')) {
      this.swiper.allowTouchMove = false;
    }
    this.addEventListener("touchmove", this.imageWrapperMove);
    document.addEventListener("touchend", this.onTouchEnd);
  }

  onMouseUp() {
    this.removeEventListener("mousemove", this.imageWrapperMove);
    document.removeEventListener("mouseup", this.onMouseUp);
    if (this.getAttribute('swiper-id')) {
      this.swiper.allowTouchMove = true;
    }
  }

  onTouchEnd() {
    this.removeEventListener("touchmove", this.imageWrapperMove);
    document.removeEventListener("touchend", this.onTouchEnd);
    if (this.getAttribute('swiper-id')) {
      this.swiper.allowTouchMove = true;
    }
  }

  imageWrapperMoveFc(e) {
    e.preventDefault();
    e.stopPropagation();

    let offsetX;
    if (e.type === 'mousemove') {
      offsetX = e.clientX - this.getBoundingClientRect().left;
    } else if (e.type === 'touchmove') {
      offsetX = e.touches[0].clientX - this.getBoundingClientRect().left;
    }
    const newLeft = Math.min(Math.max(offsetX, this.minLeft), this.maxLeft);
    const newWidth = `${(newLeft / this.imageWrapperWidth) * 100}%`;
    this.button.style.left = newWidth;
    this.upImage.style.width = newWidth;
  }
  update() {
    this.imageWrapperWidth = this.getBoundingClientRect().width;
    this.minLeft = this.imageWrapperWidth * this.minRatio;
    this.maxLeft = this.imageWrapperWidth * this.maxRatio;
  }
}
customElements.define('sliding-card-wrapper', SlidingCardWrapper);

class defaultSwitchComponent extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.defaultClassList = this.getAttribute('default-classlist')?.split(',');
    this.activeClassList = this.getAttribute('active-classlist')?.split(',');
    this.lastActiveIndex = 0;
    this.eventType = this.getAttribute('event-type') || "click";

    this.autoplay = this.hasAttribute('autoplay');
    this.autoplayDelay = parseInt(this.getAttribute('autoplay-delay')) || 5000;
    this.autoplayTimer = null;
    this.pauseOnHover = this.hasAttribute('pause-on-hover');

    this.nextClassName = this.getAttribute('next-classname');

    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px' });
    this.observer.observe(this);
  }
  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.init();
        this.observer.unobserve(this);
      }
    });
  }
  init() {
    if (Array.isArray(this.defaultClassList) && this.defaultClassList.length > 0) {
      this.switchNodes = this.querySwitchNodes();
      this.switchNodes[0].forEach((item, index) => {
        item.addEventListener(this.eventType, () => {
          if (item.classList.contains(this.activeClassList[0])) {
            return;
          }
          this.switchChange(index);
          if (this.autoplay) {
            this.restartAutoplay();
          }
        });
      });
    }
    if (this.getAttribute('action-button')) {
      this.actionButtons = this.querySelectorAll(`.${this.getAttribute('action-button')}`);
      this.actionButtons.forEach((item, index) => {
        item.addEventListener(this.eventType, () => {
          if (item.classList.contains('selected')) {
            return;
          }
          this.switchChange(index);
          if (this.autoplay) {
            this.restartAutoplay();
          }
        });
      });
    }

    if (this.nextClassName) {
      this.nextButtons = this.querySelectorAll(`.${this.nextClassName}`);
      this.nextButtons.forEach(btn => {
        btn.addEventListener(this.eventType, () => {
          this.next();
          if (this.autoplay) this.restartAutoplay();
        });
      });
    }

    if (this.autoplay) {
      this.startAutoplay();
      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }
  }
  querySwitchNodes() {
    let switchNodes = [];
    this.defaultClassList.forEach(className => switchNodes.push(this.querySelectorAll(`.${className}`)));
    return switchNodes;
  }
  switchChange(index) {
    const newActiveIndex = index;
    this.switchNodes.forEach((nodes, idx) => {
      const lastActiveNode = nodes[this.lastActiveIndex];
      if (lastActiveNode) {
        lastActiveNode.classList.remove(this.activeClassList[idx]);
      }
    });

    this.switchNodes.forEach((nodes, idx) => {
      const newActiveNode = nodes[newActiveIndex];
      if (newActiveNode) {
        newActiveNode.classList.add(this.activeClassList[idx]);
      }
    });
    this.lastActiveIndex = newActiveIndex;
  }

  next() {
    if (!this.switchNodes || !this.switchNodes.length) return;
    const nextIndex = (this.lastActiveIndex + 1) % this.switchNodes[0].length;
    this.switchChange(nextIndex);
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      let nextIndex = (this.lastActiveIndex + 1) % this.switchNodes[0].length;
      this.switchChange(nextIndex);
    }, this.autoplayDelay);
  }
  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

customElements.define('default-switch-component', defaultSwitchComponent);

class CountUpElement extends HTMLElement {
  constructor() {
    super();
    this.regex = /(\d+),(\d+)/g;
  }
  connectedCallback() {
    this.count = this.textContent
    if (isNaN(parseInt(this.count))) {
      return
    }
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px' });
    this.observer.observe(this);
  }
  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) { this.start(); this.observer.unobserve(this); }
    });
  }
  formatNumber(number) {
    const numStr = number.toFixed(0);
    const formattedNumber = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formattedNumber;
  }
  start() {
    const targetValue = parseInt(this.textContent.replace(this.regex, "$1$2"));
    this.animation(
      2000,
      targetValue - 1000 >= 1000
        ? Math.round((targetValue - 1000) / 1000) * 1000
        : 0,
      targetValue,
      (val) => {
        this.textContent = this.formatNumber(val);
      }
    );
  }

  animation(duration, from, to, onProgress) {
    if (from === to) return;
    let value = from;
    const speed = (to - from) / duration;
    const start = Date.now();

    function _run() {
      const t = Date.now() - start;
      if (t >= duration) {
        value = to;
        onProgress(value);
        return;
      }

      value = from + t * speed;
      onProgress(value);
      requestAnimationFrame(_run);
    }
    _run();
  }
}

customElements.define('custom-countup', CountUpElement);

class DefaultSwiper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.section = document.getElementById(this.getAttribute('section-id'));
    this.observerEl = this.section || this;
    this.swiperId = this.getAttribute('swiper-id');
    if (!this.swiperId) {
      return
    }
    this.options = JSON.parse(this.getAttribute('data-options'));
    this.directInit = this.getAttribute('direct-init')
    if (this.directInit) {
      this.init()
    } else {
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '100px' });
      this.observer.observe(this.observerEl);
    }

  }
  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) { this.init(); this.observer.unobserve(this.observerEl); }
    });
  }
  init() {
    new Swiper(this, this.options)
  }
}

customElements.define('default-swiper', DefaultSwiper);

class customBuyButton extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.clickButton = this.querySelector(".custom-buy-button");
    if (this.getAttribute("disabled")) {
      return;
    }
    if (this.clickButton) {
      this.init();
    }
  }
  init() {
    this.clickButton.addEventListener("click", () => {
      this.buyButton = this.querySelector(
        ".shopify-payment-button__more-options"
      );
      if (this.buyButton) {
        this.buyButton.click();
        return;
      }
      this.buyButton2 = this.querySelector(".shopify-payment-button__button");
      if (this.buyButton2) {
        this.buyButton2.click();
        return;
      }
      this.form = this.querySelector("form");
      if (this.form) {
        this.form.submit();
      }
    });
  }
}

customElements.define("custom-buy-button", customBuyButton);

class DelayContent extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.delayAnimateEl = this.querySelectorAll('.delay-animate')
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px', threshold: 0 });
    this.observer.observe(this);
  }
  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) { this.start(); this.observer.unobserve(this); }
    });
  }
  start() {
    if (this.delayAnimateEl.length > 0) {
      this.delayAnimateEl.forEach((item, index) => {
        item.classList.add('is-loaded')
      })
    }

  }
}

customElements.define('delay-content', DelayContent);

class AnchorButton extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init() {
    this.addEventListener('click', (event) => {
      this.targetId = this.getAttribute('target-id')
      this.scrollBlock = this.getAttribute('scroll-block') || 'center'
      if (this.targetId) {
        const targetItem = document.querySelector(this.targetId)
        event.preventDefault();
        targetItem.scrollIntoView({
          behavior: 'smooth',
          block: this.scrollBlock
        });
      }
    })
  }
}
customElements.define('anchor-button', AnchorButton);

class CustomModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener("DOMContentLoaded", () => {
      this.init();
    });
  }
  init() {
    this.showButton = document.querySelector(this.getAttribute("show-class"));
    this.closeButton = document.querySelector(this.getAttribute("close-class"));
    this.maskButton = document.querySelector(this.getAttribute("mask-class"));
    if (this.showButton) {
      this.showButton.addEventListener("click", () => {
        this.classList.remove("hidden");
        if (this.showButton.classList.contains('product-info__variant-details-show')) {
          const rect = this.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const elementBottom = rect.bottom + scrollTop;
          const viewportHeight = window.innerHeight;
          const isElementInViewport = (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= viewportHeight &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          );

          if (!isElementInViewport) {
            window.scrollTo({
              top: elementBottom - viewportHeight + 10,
              behavior: 'smooth'
            });
          }
        }
      });
    }
    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => {
        this.classList.add("hidden");
      });
    }
    if (this.maskButton) {
      this.maskButton.addEventListener("click", () => {
        this.classList.add("hidden");
      });
    }
  }
}
customElements.define('custom-modal', CustomModal);

function copyCpnCode(element) {
  const old_text = element.innerHTML;
  let cpnCode;
  if (element.dataset.text) {
    cpnCode = element.dataset.text;
  } else {
    cpnCode = element.innerHTML;
  }
  navigator.clipboard.writeText(cpnCode.trim());

  element.innerHTML = "Copied";
  element.classList.add('discount-copied')
  setTimeout(function () {
    element.innerHTML = old_text;
    element.classList.remove('discount-copied')
  }, 4000);
}

class AutoHeightTable extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = null;
    this.init();
  }

  init() {
    this.columns = this.querySelectorAll('.table_column');
    if (!this.columns.length) return;
    this.totalRows = this.columns[0].children.length;

    this.syncHeights();
    this.resizeObserver = new ResizeObserver(() => {
      this.syncHeights();
    });
    this.resizeObserver.observe(this);
  }

  syncHeights() {
    for (let i = 0; i < this.totalRows; i++) {
      let maxHeight = 0;
      this.columns.forEach((column) => {
        const cell = column.children[i];
        maxHeight = Math.max(maxHeight, cell.offsetHeight);
      });
      this.columns.forEach((column) => {
        const cell = column.children[i];
        cell.style.height = `${maxHeight}px`;
      });
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}

customElements.define('auto-height-table', AutoHeightTable);

class BestSellProductListContent extends HTMLElement {
  constructor() {
    super();
    this.section = document.querySelector(`#${this.dataset.sectionId}`);
    this.bestSellList = this.querySelectorAll("bestsell-product-list");
  }
  connectedCallback() {
    if (this.bestSellList.length > 1) {
      this.initTabs()
    }
  }
  initTabs() {
    const naviWapper = this.section.querySelector(".best-sell__product-list-tabs-labels")
    let tabIndex = 0;
    let labelsChildren = ''
    this.bestSellList.forEach((item, index) => {
      let tabItem = ''
      if (index === 0) {
        tabItem = `<div class='best-sell__product-list-tabs-label selected' data-index="${index}">${item.dataset.tabName}</div>`
      } else {
        tabItem = `<div class='best-sell__product-list-tabs-label' data-index="${index}"> ${item.dataset.tabName}</div>`
      }
      labelsChildren += tabItem
    })
    naviWapper.innerHTML = labelsChildren

    naviWapper.addEventListener("click", (e) => {
      const target = e.target
      if (target.classList.contains("best-sell__product-list-tabs-label") && !target.classList.contains("selected")) {
        naviWapper.children[tabIndex].classList.remove("selected")
        this.bestSellList[tabIndex].classList.remove("selected")
        target.classList.add("selected")
        this.bestSellList[target.dataset.index].classList.add("selected")
        tabIndex = target.dataset.index
      }
    })
  }
}

customElements.define("bestsell-product-list-content", BestSellProductListContent);

class BestSellProductList extends HTMLElement {
  constructor() {
    super();
    this.productSlide = this.querySelectorAll(".best-sell__product-item");
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.productSlide.forEach((product, index) => {
      const variantGroup = product.querySelector(
        ".best-sell__product-variants"
      );
      const firstVariant = product.querySelector(
        ".best-sell__product-variant"
      );
      if (variantGroup) {
        variantGroup.addEventListener("click", (e) => {
          if (
            e.target &&
            e.target.classList.contains("best-sell__product-variant") &&
            !e.target.classList.contains("selected")
          ) {
            variantGroup
              .querySelector(".selected")
              .classList.remove("selected");
            e.target.classList.add("selected");
            this.updateVariant(product, e.target);
          }
        });
      }
      if (firstVariant) {
        firstVariant.classList.add("selected");
        this.updateVariant(product, firstVariant);
      }
    });
  }
  updateVariant(currentSlide, variantElement) {
    const addButonVariantId = currentSlide.querySelector(
      ".best-sell__product-add-input"
    );
    const priceBox = currentSlide.querySelector(
      ".best-sell__product-price-box"
    );
    priceBox.innerHTML = `<span class="best-sell__product-price">${variantElement.dataset.price}</span>
            <del class="best-sell__product-old_price">${variantElement.dataset.oldPrice}</del>`;
    addButonVariantId.value = variantElement.dataset.sku;
  }
}

customElements.define("bestsell-product-list", BestSellProductList);

class ResultReviewsSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.groups = document.querySelectorAll(`#result-reviews-slider__section-${this.dataset.sectionId} .result-reviews-slider__group`)
    this.groups.forEach((group) => {
      new Swiper(group, {
        speed: 600,
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          0: {
            slidesPerView: 1,
            spaceBetween: 15
          },
        },
        pagination: {
          el: '.result-reviews-slider_nav-page',
          clickable: true
        },
        navigation: {
          nextEl: `.swiper-button-next-${this.dataset.sectionId}-${group.dataset.blockIndex}`,
          prevEl: `.swiper-button-prev-${this.dataset.sectionId}-${group.dataset.blockIndex}`,
        }
      })
    })

  }
}

customElements.define("result-reviews-slider", ResultReviewsSlider);

class ProductInfoPaymentsAccordion extends HTMLElement {
  connectedCallback() {
    const summarys = this.querySelectorAll('.product__accordion-payments-summary');

    summarys.forEach(summary => {
      summary.addEventListener('click', function () {
        const parentWrap = this.closest('.product__accordion-payments-wrap');
        parentWrap && parentWrap.classList.toggle('selected');
      });
    });
  }
}

customElements.define('product-info-payments-accordion', ProductInfoPaymentsAccordion);

class VideoWrapper extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.voiceIconSize = this.dataset.voiceIconSize || 40
  }

  connectedCallback() {
    const video = this.querySelector('video');
    if (!video) return;

    const disableClick = this.hasAttribute('disable-click');
    const disableMute = this.hasAttribute('disable-mute');
    const disableProgress = this.hasAttribute('disable-progress');

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          position: relative;
          display: flex;
          justify-content: center;
          align-items:center;
          width: 100%;
          overflow: hidden;
        }

        ::slotted(video) {
          width: 100%;
          height: auto;
          display: block;
          cursor: pointer;
        }

        .video-progress-bar {
          position: absolute;
          top: 0;
          left: 0;
          height: 6px;
          width: 0%;
          background-color: white;
          border-radius: 4px;
          transition: width 0.1s linear;
          z-index: 3;
        }

        .muted-icon {
          position: absolute;
          top: 12px;
          right: 8px;
          width: ${this.voiceIconSize}px;
          height: ${this.voiceIconSize}px;
          cursor: pointer;
          z-index: 9;
        }

        .muted-icon svg {
          width: 100%;
          height: 100%;
        }

        .muted-icon[data-muted="true"] .t-muted {
          display: none;
        }

        .muted-icon[data-muted="false"] .f-muted {
          display: none;
        }

        .video-wrapper-play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 52px;
          height: 52px;
          background: rgba(0, 0, 0, 0.35);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 5;
          transition: opacity 0.3s ease;
        }

        .video-wrapper-play svg {
          width: 32px;
          height: 32px;
          fill: #fff;
        }

        .video-wrapper-play.hidden {
          opacity: 0;
          pointer-events: none;
        }
      </style>

      ${disableProgress ? '' : `<div class="video-progress-bar"></div>`}

      ${disableMute ? '' : `
      <div class="muted-icon" data-muted="false">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
          <g class="f-muted">
            <rect width="30" height="30" rx="15" fill="#190A0A" fill-opacity="0.3"></rect>
            <path d="M14.3711 11.7205C14.3711 11.1615 13.7245 10.8507 13.288 11.1999L11.0378 13H9.03776C8.66957 13 8.37109 13.2985 8.37109 13.6667V16.3334C8.37109 16.7016 8.66957 17 9.03776 17H11.0378L13.288 18.8002C13.7245 19.1494 14.3711 18.8386 14.3711 18.2796V11.7205Z" fill="white"></path>
            <path d="M20.998 13.0001L16.998 17.0001" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M16.998 13.0001L20.998 17.0001" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"></path>
          </g>
          <g class="t-muted">
            <rect width="30" height="30" rx="15" fill="#190A0A" fill-opacity="0.3"></rect>
            <path d="M14.3711 11.7205C14.3711 11.1615 13.7245 10.8507 13.288 11.1999L11.0378 13H9.03776C8.66957 13 8.37109 13.2985 8.37109 13.6667V16.3334C8.37109 16.7016 8.66957 17 9.03776 17H11.0378L13.288 18.8002C13.7245 19.1494 14.3711 18.8386 14.3711 18.2796V11.7205Z" fill="white"></path>
            <path d="M19.074 10.7867C20.3238 12.0369 21.0259 13.7323 21.0259 15.5001C21.0259 17.2678 20.3238 18.9632 19.074 20.2134M16.7207 13.1401C17.3456 13.7652 17.6967 14.6129 17.6967 15.4967C17.6967 16.3806 17.3456 17.2283 16.7207 17.8534" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"></path>
          </g>
        </svg>
      </div>`}

      ${disableClick ? '' : `<div class="video-wrapper-play">
        <svg viewBox="0 0 1024 1024">
          <path d="M755.552 495.36l-384-296.672a31.936 31.936 0 0 0-51.552 25.28v593.504a32 32 0 0 0 51.552 25.28l384-296.704a32 32 0 0 0 0-50.656" fill="#ffffff"></path>
        </svg>
      </div>`}

      <slot></slot>
    `;

    this.progressBar = this.shadowRoot.querySelector('.video-progress-bar');
    this.mutedIcon = this.shadowRoot.querySelector('.muted-icon');
    this.playButton = this.shadowRoot.querySelector('.video-wrapper-play');

    this.updateMutedIcon(video.muted);
    this.updatePlayButton(video.paused);

    if (!disableProgress) {
      video.addEventListener('timeupdate', () => {
        const progress = (video.currentTime / video.duration) * 100;
        this.progressBar.style.width = `${progress}%`;
      });
      video.addEventListener('ended', () => {
        this.progressBar.style.width = '0%';
        this.updatePlayButton(true);
      });
    }


    if (!disableClick) {
      video.addEventListener('play', () => this.updatePlayButton(false));
      video.addEventListener('pause', () => this.updatePlayButton(true));
      video.addEventListener('click', () => {
        if (video.paused) video.play();
        else video.pause();
      });
      this.playButton.addEventListener('click', () => video.play());
    }

    if (!disableMute && this.mutedIcon) {
      this.mutedIcon.addEventListener('click', () => {
        video.muted = !video.muted;
        this.updateMutedIcon(video.muted);
      });
    }
  }

  updateMutedIcon(isMuted) {
    if (this.mutedIcon)
      this.mutedIcon.setAttribute('data-muted', String(isMuted));
  }

  updatePlayButton(isPaused) {
    if (this.playButton) {
      if (isPaused) this.playButton.classList.remove('hidden');
      else this.playButton.classList.add('hidden');
    }
  }
}

customElements.define('video-wrapper', VideoWrapper);
